module.exports = __webpack_public_path__ + "static/media/global.2a1656dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/modelo/global.svg
// module id = 191
// module chunks = 0